import React, { useState } from "react";
import { Card, Button, Typography, Space, message } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { useAuth0 } from "../../../react-auth0-spa";
import { useAppContext } from "../../../context";
import config from "../../../api_config.json";
import "./OrgZoho.css";

const { Title, Paragraph } = Typography;

const OrgZoho = ({ orgId }) => {
  const { getTokenSilently } = useAuth0();
  const { isProd } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [celebrate, setCelebrate] = useState(false);
  const [emojis, setEmojis] = useState([]);

  const generateEmojis = () => {
    // Heavily bias towards flags
    const pool = [
      ...Array(28).fill("🇮🇳"),
      "🍛", "🍛", "🥘", "🍚", "🫓", "🪔",
    ];
    return Array.from({ length: 50 }).map((_, i) => {
      const left = Math.random() * 100; // vw
      const delay = Math.random() * 0.5; // s
      const duration = 2.2 + Math.random() * 1.4; // s
      const size = 36 + Math.random() * 36; // px (bigger)
      const icon = pool[Math.floor(Math.random() * pool.length)];
      const rotation = Math.random() > 0.5 ? 360 : -360;
      return { id: i, left, delay, duration, size, icon, rotation };
    });
  };

  const startAnimation = () => {
    setEmojis(generateEmojis());
    setCelebrate(true);
    // Hide after a short burst
    window.setTimeout(() => setCelebrate(false), 2600);
  };

  const syncWithZoho = async () => {
    try {
      setLoading(true);
      startAnimation();
      const token = await getTokenSilently();
      const response = await fetch(
        `${config.baseUrl[isProd ? "prod" : "dev"]}/crm/sync/org/${orgId}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || `Errore HTTP ${response.status}`);
      }

      message.success("Sincronizzazione avviata con successo");
    } catch (err) {
      console.error(err);
      message.error("Errore nell'avviare la sincronizzazione");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Title level={4} style={{ margin: 0 }}>
          Zoho CRM
        </Title>
        <Paragraph style={{ marginBottom: 0 }}>
          Sincronizza l'anagrafica dell'organizzazione con Zoho CRM.
        </Paragraph>
        <div>
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={syncWithZoho}
            loading={loading}
          >
            Sincronizza org con CRM Zoho
          </Button>
        </div>
        {celebrate && (
          <div className="zoho-celebrate-overlay" aria-hidden>
            {emojis.map((e) => (
              <span
                key={e.id}
                className="zoho-emoji"
                style={{
                  left: `${e.left}vw`,
                  animationDelay: `${e.delay}s`,
                  animationDuration: `${e.duration}s`,
                  fontSize: `${e.size}px`,
                  // Use CSS var to control rotation direction per item
                  "--rot": `${e.rotation}deg`,
                }}
              >
                {e.icon}
              </span>
            ))}
          </div>
        )}
      </Space>
    </Card>
  );
};

export default OrgZoho;
